export const AbilityIndexToKey: { [key: string]: string } = {
  0: 'PASSIVE',
  1: 'Q',
  2: 'W',
  3: 'E',
  4: 'R',
};
